/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useTranslation } from "react-i18next";
import { special_needs } from "../../constant/dummyData";

const TopicsSpecial = () => {
  const { t } = useTranslation(); // Initialize translation

  return (
    <div className="section-padding">
      <div className="container">
        <div className="text-center">
          <div className="mini-title">{t("special_needs.mini_title")}</div>
          <div className="column-title">
            {t("special_needs.title").split(" ")[0]}{" "}
            <span className="shape-bg">
              {t("special_needs.title").split(" ")[1]}
            </span>{" "}
            {t("special_needs.title").split(" ").slice(2).join(" ")}
          </div>
        </div>
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] pt-10">
          {special_needs.map((item, index) => (
            <a
              className="rounded-[8px] transition duration-100 hover:shadow-box hover:bg-white group bg-[#FFE8E8] text-center px-6 py-[65px] hover:-translate-y-2"
              href="#"
              key={index}
            >
              <div className="w-[72px] h-[72px] rounded-full bg-white relative mx-auto flex flex-col justify-center items-center mb-8 group-hover:bg-[#FFE8E8]">
                <img
                  src={item.logo}
                  alt=""
                  className="w-[72px] h-[72px] object-cover"
                />
              </div>
              <div className="course-content">
                <h4 className="text-2xl mb-2 font-bold">
                  {t(`special_needs.${index + 1}.title`)}
                </h4>
                <p>{t(`special_needs.${index + 1}.quantity`)}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopicsSpecial;
